// Local aliases for the long Orval-generated type names used by the
// SaaS-Owner Admin Cockpit (tenants admin, plans, tenant invoices, support).
// Never import the raw Facility...Dtos... names directly in pages/stores —
// use these aliases so refactors stay scoped to one file.

import type {
  FacilityFlowCoreModulesSubscriptionPlansDtosCreateSubscriptionPlanRequest,
  FacilityFlowCoreModulesSubscriptionPlansDtosPublicSubscriptionPlanDto,
  FacilityFlowCoreModulesSubscriptionPlansDtosSubscriptionPlanDto,
  FacilityFlowCoreModulesSubscriptionPlansDtosUpdateSubscriptionPlanRequest,
  FacilityFlowCoreModulesSupportDtosCreateSupportTicketRequest,
  FacilityFlowCoreModulesSupportDtosReplyToSupportTicketRequest,
  FacilityFlowCoreModulesSupportDtosSupportTicketDto,
  FacilityFlowCoreModulesSupportDtosSupportTicketReplyDto,
  FacilityFlowCoreModulesSupportDtosUpdateSupportTicketStatusRequest,
  FacilityFlowCoreModulesTenantBillingDtosGenerateMonthlyTenantInvoicesRequest,
  FacilityFlowCoreModulesTenantBillingDtosTenantInvoiceDto,
  FacilityFlowCoreModulesTenantBillingDtosTenantInvoicePositionDto,
  FacilityFlowCoreModulesTenantBillingWorkflowsGenerateMonthlyTenantInvoicesResponse,
  FacilityFlowCoreModulesTenantsDtosTenantStatisticsDto,
  FacilityFlowCoreModulesTenantsWorkflowsChangeTenantPlanRequest,
} from '../generated/models';

import { FacilityFlowCoreModulesSupportEntitiesSupportTicketStatus } from '../generated/models/facilityFlowCoreModulesSupportEntitiesSupportTicketStatus';
import { FacilityFlowCoreModulesSupportEntitiesSupportTicketType } from '../generated/models/facilityFlowCoreModulesSupportEntitiesSupportTicketType';
import { FacilityFlowCoreModulesTenantBillingEntitiesTenantInvoiceStatus } from '../generated/models/facilityFlowCoreModulesTenantBillingEntitiesTenantInvoiceStatus';
import { FacilityFlowCoreModulesTenantsEntitiesBusinessPlan } from '../generated/models/facilityFlowCoreModulesTenantsEntitiesBusinessPlan';

// ─────────── Subscription Plans ───────────
export type SubscriptionPlanDto = FacilityFlowCoreModulesSubscriptionPlansDtosSubscriptionPlanDto;
export type PublicSubscriptionPlanDto = FacilityFlowCoreModulesSubscriptionPlansDtosPublicSubscriptionPlanDto;
export type CreateSubscriptionPlanRequest = FacilityFlowCoreModulesSubscriptionPlansDtosCreateSubscriptionPlanRequest;
export type UpdateSubscriptionPlanRequest = FacilityFlowCoreModulesSubscriptionPlansDtosUpdateSubscriptionPlanRequest;

// ─────────── Tenant Billing ───────────
export type TenantInvoiceDto = FacilityFlowCoreModulesTenantBillingDtosTenantInvoiceDto;
export type TenantInvoicePositionDto = FacilityFlowCoreModulesTenantBillingDtosTenantInvoicePositionDto;
export type GenerateMonthlyTenantInvoicesRequest = FacilityFlowCoreModulesTenantBillingDtosGenerateMonthlyTenantInvoicesRequest;
export type GenerateMonthlyTenantInvoicesResponse = FacilityFlowCoreModulesTenantBillingWorkflowsGenerateMonthlyTenantInvoicesResponse;

// ─────────── Support ───────────
export type SupportTicketDto = FacilityFlowCoreModulesSupportDtosSupportTicketDto;
export type SupportTicketReplyDto = FacilityFlowCoreModulesSupportDtosSupportTicketReplyDto;
export type CreateSupportTicketRequest = FacilityFlowCoreModulesSupportDtosCreateSupportTicketRequest;
export type UpdateSupportTicketStatusRequest = FacilityFlowCoreModulesSupportDtosUpdateSupportTicketStatusRequest;
export type ReplyToSupportTicketRequest = FacilityFlowCoreModulesSupportDtosReplyToSupportTicketRequest;

// ─────────── Tenants (admin) ───────────
export type TenantStatisticsDto = FacilityFlowCoreModulesTenantsDtosTenantStatisticsDto;
export type ChangeTenantPlanRequest = FacilityFlowCoreModulesTenantsWorkflowsChangeTenantPlanRequest;

// ─────────── Enums (re-export as namespaced const + type) ───────────
export const BusinessPlan = {
  Free: 0,
  Starter: 1,
  Professional: 2,
  Enterprise: 3,
} as const;
export type BusinessPlan = (typeof BusinessPlan)[keyof typeof BusinessPlan];

export const TenantInvoiceStatus = {
  Draft: 0,
  Issued: 1,
  Paid: 2,
  Cancelled: 3,
} as const;
export type TenantInvoiceStatus = (typeof TenantInvoiceStatus)[keyof typeof TenantInvoiceStatus];

export const SupportTicketStatus = {
  New: 0,
  InProgress: 1,
  Closed: 2,
} as const;
export type SupportTicketStatus = (typeof SupportTicketStatus)[keyof typeof SupportTicketStatus];

export const SupportTicketType = {
  Question: 0,
  Problem: 1,
  NewTenantRequest: 2,
  MeetingRequest: 3,
  Other: 99,
} as const;
export type SupportTicketType = (typeof SupportTicketType)[keyof typeof SupportTicketType];

// Compatibility re-exports (in case generated enums are referenced via barrel):
export {
  FacilityFlowCoreModulesSupportEntitiesSupportTicketStatus as SupportTicketStatusEnum,
  FacilityFlowCoreModulesSupportEntitiesSupportTicketType as SupportTicketTypeEnum,
  FacilityFlowCoreModulesTenantBillingEntitiesTenantInvoiceStatus as TenantInvoiceStatusEnum,
  FacilityFlowCoreModulesTenantsEntitiesBusinessPlan as BusinessPlanEnum,
};
